import * as React from 'react';
import {useEffect} from 'react';
import api from "../../utils/api";
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import {useNavigate} from 'react-router-dom';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {Checkbox, ListItemText} from "@mui/material";
import ManIcon from '@mui/icons-material/Man';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
import {useLocation} from "react-router-dom";
import * as util from "../../utils/util";
import { notifyApiError } from "../../utils/apiError";

const typeMemberProfile = {
  id: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: '', companyId: ''
  ,email: '', zipCode: '', beforePassword: '', password: '', 
  height: '', weight: '',
  interest_disease: '', is_medicine: '', work_strength: ''
};

const UserJoinPhysical = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = { ...location.state };
  const [memberProfile, setMemberProfile] = React.useState(typeMemberProfile);
  const [heightError, setHeightError] = React.useState(true);
  const [weightError, setWeightError] = React.useState(true);

  useEffect(() => {
    userInfo.interest_disease = '';
    userInfo.is_medicine = '';
    userInfo.work_strength = '';
    setMemberProfile(userInfo);
  }, []);
  
  // 앱 회원 가입
  function handleSaveUser(){
    if(util.strNull(memberProfile.height) === '' || heightError){
      alert('신장을 올바르게 입력해주세요.');
    }else if(util.strNull(memberProfile.weight) === '' || weightError){
      alert('체중을 올바르게 입력해주세요.');
    }else if(util.strNull(memberProfile.work_strength) === ''){
      alert('평상시 활동량을 입력해주세요.');
    }else if(util.strNull(memberProfile.interest_disease) === ''){
      alert('관심 질병을 입력해주세요.');
    }else if(util.strNull(memberProfile.is_medicine) === ''){
      alert('복용약을 입력해주세요.');
    }else{
      api.post('auth/signupCustomer', memberProfile).then((res:any) => {
        if(util.strNull(res.data.code) === 'success'){
          alert(res.data.message + '\n' + '안드로이드 사용자는 구글피트니스 애플리케이션의 걸음수를 활용합니다. 필요 시 설치해주세요.');
          navigate('/login');
        }else{
          alert(res.data.message + '\n' + '고객센터에 문의해주세요.');
        }
      }).catch(function (error:any) {
        // 가입이 됐는지 안 됐는지 모른 채 남겨두지 않는다
        notifyApiError(error, '회원가입을 완료하지 못했습니다.');
      });
    }
  }

  // 신장 입력 핸들러
  function handleChangeHeight(val: any) {
    setMemberProfile((prev) => true ? { ...prev, height: val } : prev);
    if (val >= 50 && val <= 250) {
      setHeightError(false);
    } else {
      setHeightError(true);
    }
  }

  // 체중 입력 핸들러
  function handleChangeWeight(val: any) {
    setMemberProfile((prev) => true ? { ...prev, weight: val } : prev);
    if (val >= 10 && val <= 300) {
      setWeightError(false);
    } else {
      setWeightError(true);
    }
  }



  return (

    <Stack sx={{ width: '100%', minWidth: 320, minHeight:'100vh', background: '#F1F2F4', pt: 5, pb: 5, boxSizing: 'border-box' }} spacing={6}>
      <Top title="회원 가입" />



      <Stack sx={{ pb: 6, pl: 2, pr: 2, }}>
        <Typography sx={{ m: '0px auto 20px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>맞춤형 건강관리를 위해서 기록해주세요.</Typography>


        <Card sx={{ p: '20px 20px 30px 20px', bgcolor: '#fff' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'end'}>
              <ManIcon sx={profileIcon} />
              <TextField
                label="신장"
                id=""
                fullWidth
                value={memberProfile.height}
                variant="standard"
                sx={loginField}
                InputProps={{
                  endAdornment: <InputAdornment position="start">cm</InputAdornment>,
                }}
                onChange={(e) => { handleChangeHeight(e.target.value) }}
                error={heightError}
                helperText={heightError ? "50 ~ 250 사이의 값을 입력해주세요." : ""}
              />
            </Stack>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'end'} sx={{ml:3}}>
              <MonitorWeightIcon sx={profileIcon} />
              <TextField
                label="체중"
                id=""
                value={memberProfile.weight}
                variant="standard"
                sx={loginField}
                fullWidth
                InputProps={{
                  endAdornment: <InputAdornment position="start">kg</InputAdornment>,
                }}
                onChange={(e) => { handleChangeWeight(e.target.value) }}
                error={weightError}
                helperText={weightError ? "10 ~ 300 사이의 값을 입력해주세요." : ""}
              />
            </Stack>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
            <DirectionsRunIcon sx={profileIcon} />
            <FormControl fullWidth sx={loginField}>
              <InputLabel id="select-label-active" sx={{ fontSize: 14 }} >평상시 활동량</InputLabel>
              <Select
                labelId="select-label-active"
                id="select-label-active"
                value={memberProfile.work_strength}
                label="평상시 활동량"
                variant="standard"
                sx={loginField}
                onChange={(e: any) => {
                  setMemberProfile((prev) => true ? { ...prev, work_strength: e.target.value } : prev)
                }}
              >
                <MenuItem value="적음">적음</MenuItem>
                <MenuItem value="보통">보통</MenuItem>
                <MenuItem value="많음">많음</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
            <VaccinesIcon sx={profileIcon} />
            <FormControl fullWidth sx={loginField}>
              <InputLabel id="select-label-medi" sx={{ fontSize: 14 }}>관심 질병</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="multiple-checkbox"
                label="관심 질병"
                multiple
                value={util.strNull(memberProfile.interest_disease) !== '' ? memberProfile.interest_disease.split(',') : []}
                variant="standard"
                onChange={(e: any) => {
                  setMemberProfile((prev) => true ? { ...prev, interest_disease: e.target.value.join(',') } : prev)
                }}
                // input={<OutlinedInput label="Tag" /> }
                renderValue={(selected: any) => selected.join(',')}
                MenuProps={MenuProps}
              >
                {['없음', '당뇨', '고혈압', '비만', '이상지질', '기타'].map((name) => (
                  <MenuItem key={name} value={name} sx={{padding: '0px 10px'}}
                    disabled={
                      memberProfile.interest_disease.length > 0 && (
                        (memberProfile.interest_disease.indexOf('없음') > -1 && name !== '없음')
                        || (memberProfile.interest_disease.indexOf('없음') <= -1 && name === '없음')
                      )
                    }>
                    <Checkbox checked={memberProfile.interest_disease?.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
            <MedicationLiquidIcon sx={profileIcon} />
            <FormControl fullWidth sx={loginField}>
              <InputLabel id="select-label-par" sx={{ fontSize: 14 }}>복용약</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                label="복용약"
                multiple
                value={util.strNull(memberProfile.is_medicine) !== '' ? memberProfile.is_medicine.split(',') : []}
                variant="standard"
                sx={loginField}
                onChange={(e: any) => {
                  setMemberProfile((prev) => true ? { ...prev, is_medicine: e.target.value.join(',') } : prev)
                }}
                // input={<OutlinedInput label="Tag" />}
                renderValue={(selected: any) => selected.join(',')}
                MenuProps={MenuProps}
              >
                {['없음', '당뇨', '고혈압', '이상지질', '건강기능보조제', '기타'].map((name) => (
                  <MenuItem key={name} value={name} sx={{padding: '0px 10px'}}
                    disabled={
                      memberProfile.is_medicine.length > 0 && (
                        (memberProfile.is_medicine.indexOf('없음') > -1 && name !== '없음')
                        || (memberProfile.is_medicine.indexOf('없음') <= -1 && name === '없음')
                      )
                    }>
                    <Checkbox checked={memberProfile.is_medicine?.indexOf(name) > -1} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>


        </Card>

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle} onClick={handleSaveUser} >
            저장하기
          </Button>
        </Box>


      </Stack>


      <Bottom />
    </Stack>

  );
}

const ITEM_HEIGHT = 65;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const loginField = {
  '& input': {
    fontSize: 16,
    textAlign:'right',
    pr:2
  },
  '& p': {
    fontSize: 14
  },
  '& .MuiSelect-select': {
    fontSize: 14
  },
  '& label': {
    color: '#888',
    fontSize: 16,
    transform: 'translate(0, -1.5px) scale(0.75)'
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};
const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 10,
  boxSizing: 'border-box',
};


const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

export default UserJoinPhysical;